<template>
    <div class="tsa-previewVideo" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="close-container">
                <span class="tsa-icon-close2" @click="close"></span>
            </div>
            <video-player
                class="video-player
                vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
                @loadeddata="loadeddata"
            ></video-player>
        </div>
    </div>
</template>

<script>
import playerOptions from '@/common/copyright/video-player'
export default {
    data () {
        return {
            show: false,
            playerOptions: JSON.parse(JSON.stringify(playerOptions)),
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.resetPlay()
            } else {
                this.$refs.videoPlayer.player.play()
            }
        }
    },
    methods: {
        loadeddata () {
            if (this.show) {
                this.$refs.videoPlayer.player.play()
            }
        },
        close () {
            this.show = false
        },
        resetPlay () {
            if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.player.pause()
                this.$refs.videoPlayer.player.currentTime(0)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-previewVideo {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 860px;
            padding: 10px 12px;
            border-radius: 20px;
            background: #ffffff;
            .close-container {
                position: absolute;
                right: -30px;
                top: -30px;
                font-size: 30px;
                color: #fff;
                cursor: pointer;
                z-index: 2;
            }
            :deep(.video-player) {
                border-radius: 10px;
                overflow: hidden;
                .vjs-big-play-button {
                    border-radius: 50%;
                    width: 120px;
                    height: 120px !important;
                    overflow: hidden;
                    border: none;
                    line-height: 66px !important;
                    font-size: 40px !important;
                    line-height: 118px !important;
                    .vjs-icon-placeholder {
                        font-size: 66px;
                    }
                }
            }
        }
    }
</style>